import { CarbonOperation } from 'src/app/shared/interfaces/carbon-operation';
import { OperationType } from 'src/app/shared/interfaces/operation-type.enum';

export const OUTSIDE_B3_COUNTERPARTY_LABEL = 'Contraparte fora da B3';
export const OUTSIDE_B3_QUESTION_LABEL = 'Operação ocorreu com contraparte fora da B3?';
export const OUTSIDE_B3_ANSWER_YES = 'Sim';
export const ACX_TRADE_INFO_LINK_LABEL = 'Consulta a plataforma ACX para mais informações';

export interface OperationAcxTradeDetailsView {
  operationLabel: 'Compra' | 'Venda';
  isBuy: boolean;
  accountLabel: string;
  accountValue: string;
  outsideB3Label: string;
  outsideB3Answer: string;
  acxInfoLinkLabel: string;
}

export function isAcxBuyOperation(operation: CarbonOperation): boolean {
  return operation.rawTypeCode === OperationType.TRADE_TO;
}

export function isAcxSellOperation(operation: CarbonOperation): boolean {
  return operation.rawTypeCode === OperationType.TRADE_FROM;
}

export function isAcxTradeOperation(operation: CarbonOperation): boolean {
  return isAcxBuyOperation(operation) || isAcxSellOperation(operation);
}

export function isOutsideB3Counterparty(operation: CarbonOperation): boolean {
  if (isOutsideB3CounterpartyFlagEnabled(operation)) {
    return true;
  }

  return !operation.holderCode?.trim();
}

export function resolveAccountDisplay(value?: string | null): string {
  return value?.trim() || '-';
}

export function mapAcxTradeOperationToView(operation: CarbonOperation): OperationAcxTradeDetailsView {
  const isBuy = isAcxBuyOperation(operation);

  return {
    operationLabel: isBuy ? 'Compra' : 'Venda',
    isBuy,
    accountLabel: isBuy ? 'Conta do Comprador' : 'Conta do detentor',
    accountValue: resolveAccountDisplay(
      isBuy
        ? (operation.purchaserCode || operation.holderCode)
        : operation.holderCode,
    ),
    outsideB3Label: OUTSIDE_B3_QUESTION_LABEL,
    outsideB3Answer: OUTSIDE_B3_ANSWER_YES,
    acxInfoLinkLabel: ACX_TRADE_INFO_LINK_LABEL,
  };
}

function isOutsideB3CounterpartyFlagEnabled(operation: CarbonOperation): boolean {
  const flag = operation.counterpartyOutsideB3Indicator ?? operation.outsideB3CounterpartyIndicator;

  if (flag === true) {
    return true;
  }

  if (typeof flag === 'string') {
    const normalized = flag.trim().toUpperCase();
    return normalized === 'S' || normalized === 'SIM' || normalized === 'Y' || normalized === 'YES';
  }

  return false;
}
